import { Component, Input, ChangeDetectionStrategy } from "@angular/core"
import { Writer, User } from "modules/nav-bar/nav-bar.queries"
import { externalRoute } from "./external-routes"
import { WhiteLabelProfile } from "./nav-bar.queries"
import { get } from 'lodash-es'


@Component({
  selector: 'home-link',
  template: `
  <ng-template [ngIf]="showVerblioBrand">
    <ng-template [ngIf]="text && !logo">
    <a class="nav-link" [routerLink]="['/writer_dashboard']">{{text}}</a>
    </ng-template>
    <ng-template [ngIf]="logo">
      <div id="brand-navbar-logo"></div>
      <a *ngIf="isCurrentWriter(writer)"
        [routerLink]="['/writer_dashboard']"
        class="navbar-brand pt-0 pb-0">
          <img class="navbar-brand-img"
              id="brand-navbar-logo"
              src="/assets/verblio-logo-horizontal-light.png"
              height='34px'/>
      </a>
      <a *ngIf="!isCurrentWriter(writer)"
        href="{{ currentUser?.role == 'writer' ? linkTo('home_link') : '/'}}"
        class="navbar-brand pt-0 pb-0">
          <img class="navbar-brand-img"
              id="brand-navbar-logo"
              src="/assets/verblio-logo-horizontal-light.png"
              height='34px'/>
      </a>
    </ng-template>
  </ng-template>

  <ng-template [ngIf]="showEditspaceBrand">
    <a *ngIf="displayEditspaceLogo"
      id="editspace-logo"
      href="{{ isCustomerOrWhiteLabelUser ? linkTo('home_link') : '/' }}"
      class="navbar-brand pt-0 pb-0 d-inline-block mr-0">
        <img class="navbar-brand-img"
            src="{{ whiteLabelProfile?.logo }}"
            height='34px'/>
    </a>
    <a *ngIf="displayEditspaceName"
        id="editspace-name"
        class="py-0 nav-link d-inline-block"
        href="{{ isCustomerOrWhiteLabelUser ? linkTo('home_link') : '/' }}">
       {{whiteLabelProfile?.name}}
    </a>
  </ng-template>

  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeLink {
  @Input() currentUser: User
  @Input() text: string = 'Home'
  @Input() logo: boolean = false
  writer: Writer
  whiteLabelProfile: WhiteLabelProfile

  ngOnChanges(): void {
    if (this.currentUser) {
      if (this.currentUser.role === 'writer') {
        this.writer = this.currentUser.writer
      }
      this.whiteLabelProfile = get(this.currentUser, 'account.whiteLabelProfile')
    }
  }

  get showVerblioBrand(): boolean {
    return this.isVerblio()
  }

  get showEditspaceBrand(): boolean {
    return !this.showVerblioBrand
  }

  get displayEditspaceLogo(): boolean {
    return this.whiteLabelProfile && !!this.whiteLabelProfile.logo
  }

  get displayEditspaceName(): boolean {
    return this.whiteLabelProfile && this.whiteLabelProfile.displayName && !!this.whiteLabelProfile.name
  }

  get isCustomerOrWhiteLabelUser(): boolean {
    return ["customer", "white_label"].includes(this.currentUser?.role)
  }

  isVerblio(): boolean {
    return !window.location.hostname.includes("editspace")
  }

  linkTo(path: string, id: number | string = null): string {
    return externalRoute(path, id)
  }

  isCurrentWriter(writer: Writer): boolean {
    const currentStates = ['pending_review', 'monitored', 'active', 'unavailable']
    return writer && currentStates.includes(writer.state) && writer.commitment !== null
  }
}
